"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bovezzo": {
    "d343cf38": [{
      "hkey": "c2d005fe",
      "slug": "bovezzo",
      "name": "Bovezzo",
      "primary": true,
      "skipSearch": false
    }],
    "conicchio": [{
      "hkey": "c2d005fe",
      "slug": "bovezzo",
      "name": "Bovezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b92aaad": [{
      "hkey": "c2d005fe",
      "slug": "bovezzo",
      "name": "Bovezzo",
      "primary": true,
      "skipSearch": false
    }],
    "sant-onofrio": [{
      "hkey": "c2d005fe",
      "slug": "bovezzo",
      "name": "Bovezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;